module.exports = __webpack_public_path__ + "static/media/customPostAssessment.29d1f3db.png";